var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ol",
    {
      staticClass: "file-chooser-breadcrumb",
    },
    _vm._l(_vm.breadcrumbItems, function (folder, index) {
      return _c(
        "li",
        {
          key: folder.id,
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
              },
              on: {
                click: function click($event) {
                  $event.preventDefault()
                  return _vm.selectFolder(folder)
                },
              },
            },
            [
              _vm.rootId !== folder.id
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(folder.attributes.name) +
                        "\n            "
                    ),
                  ]
                : _c("studip-icon", {
                    attrs: {
                      shape: "home",
                      title: _vm.homeTitle,
                    },
                  }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.breadcrumbItems.length > 1 &&
          index !== _vm.breadcrumbItems.length - 1
            ? _c("span", [_vm._v("/")])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }